// extracted by mini-css-extract-plugin
export default {"onboarding-stages-links":"DealerOnboardingNavigation_onboarding-stages-links__o8jBc","active":"DealerOnboardingNavigation_active__hRPDp"};